module.exports = __webpack_public_path__ + "img/second.3bd9a1ed.svg";